import { createLocalDatabase, RoundJournal } from "./round-journal.js";
import { DeviceAccountCache } from "./device-account-cache.js";

export const localDatabase = createLocalDatabase();
export const roundJournal = new RoundJournal(localDatabase);
export const deviceAccountCache = new DeviceAccountCache(localDatabase);
